import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMenuCockpitFilled = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.3584 2.78669C11.3326 2.06199 12.6674 2.06199 13.6416 2.78669L19.6416 7.24958C20.3391 7.76848 20.75 8.58726 20.75 9.45661V19.0006C20.7499 20.5192 19.5187 21.7506 18 21.7506H6C4.48129 21.7506 3.25011 20.5192 3.25 19.0006V9.45661C3.25 8.58727 3.6609 7.76848 4.3584 7.24958L10.3584 2.78669Z",
		fill: "#311123"
	})
});
export default SvgMenuCockpitFilled;
